/**
 * LifeRamp
 *
 * @author      Ummar Hamid
 * @copyright   LifeRamp Inc.
 *
 * Built by Eonyx Infotech LLP.
 * @link https://eonyx.io
 *
 */
import React from "react";
import { Route } from "react-router-dom";

import ClientList from "./ClientList";
import UserAddEdit from "../UserAddEdit";

function Clients() {
    return (
        <>
            <Route path="/admin/clients" exact component={ClientList}></Route>
            <Route path="/admin/clients/addEdit" exact component={UserAddEdit}></Route>
        </>
    );
};

export default Clients;
